import { type Coupon, FmsApi } from "../fmsapi"
import type {
  FAR_iu_ForeignVipInvitation,
  FAR_sd_FairPoll,
  FOREIGN_VIP_PARAMS,
  FAR_sr_Fair,
  FAR_in_VisitorSendHistory,
  FAR_sr_CheckCompanyFairSmsCoupon,
  VisitorSendHistoryResponse,
  FAR_sd_AgreementMaster,
  FAR_sd_Fair,
  FairPromotion,
  FAR_sd_CompanyFairReqEnterStaff,
  FAR_sd_CompanyFacilReq,
  FAR_sr_FairDoc,
  FAR_sr_CompanyFairReqSign,
  FAR_dn_CompanyFairReqEnterStaff,
  FAR_iu_CompanyFairDocEnter,
  FAR_sr_CompanyFairReqPromotion,
  FAR_sd_FairCategoryALLFromApplication,
  FAR_sd_CompanyFairReqPromotionBrand,
  FAR_sd_CompanyFairPromotionInfoAdd,
  FAR_sr_BmsFairByFairId,
  FAR_sd_FairBoard,
  FAR_dn_CompanyFairReqPromotionBrandSingle,
  FAR_in_CompanyFairReqSign,
  FAR_in_CompanyFairPromotionWithoutFileUpload,
  FAR_sr_CompanyFairReq,
  FAR_in_CompanyFairReqPromotion,
} from "../models/responsedto"
import BaseController from "./base"
import type {
  iFAR_sd_Fair,
  iFAR_sd_AgreementMaster,
  iFairVisitorPaymentInfo,
  iFAR_sd_CompanyFacilReq,
  iFAR_dn_CompanyFairReqEnterStaff,
  iFAR_iu_CompanyFairDocEnter,
  iFAR_sd_CompanyFairPromotionInfoAdd,
  iFAR_sd_FairCategoryALLFromApplication,
  iFAR_sd_FairBoard,
  iFAR_dn_CompanyFairReqPromotionBrandSingle,
  iFAR_in_CompanyFairReqSign,
  iFAR_in_CompanyFairPromotionWithoutFileUpload,
  iFAR_in_CompanyFairReqPromotion,
  iFAR_un_CompanyFairInfoImages,
  iFAR_un_FairEvent,
  iFAR_sr_FairPeriod,
  iFAR_un_Prizes,
} from "../models/requestdto"

export class FairController extends BaseController {
  constructor(api: FmsApi) {
    super(api, "fair")
  }

  public async FAR_iu_ForeignVipInvitation(foreignVip: FOREIGN_VIP_PARAMS): Promise<FAR_iu_ForeignVipInvitation> {
    return await this.callApi("FAR_iu_ForeignVipInvitation", foreignVip)
  }

  public async draftForeignVipInvitation(foreignVip: FOREIGN_VIP_PARAMS): Promise<FAR_iu_ForeignVipInvitation> {
    return await this.callApi("draftForeignVipInvitation", foreignVip)
  }

  public async FAR_sr_ForeignVip(password: string): Promise<FAR_iu_ForeignVipInvitation> {
    return await this.callApi("FAR_sr_ForeignVip", { password: password })
  }

  public async FAR_sd_FairPoll(
    fair_id: number,
    businessType: string,
    country_code?: string | null,
    fair_consult_id?: number | null,
  ): Promise<FAR_sd_FairPoll[]> {
    return await this.callApi("FAR_sd_FairPoll", { fair_id, businessType, country_code, fair_consult_id })
  }

  public async FAR_in_VisitorSendHistory(visitorSendHistory: FAR_in_VisitorSendHistory): Promise<VisitorSendHistoryResponse> {
    const result: VisitorSendHistoryResponse[] = await this.callApi("FAR_in_VisitorSendHistory", {
      FAIR_ID: visitorSendHistory.FAIR_ID,
      CONTENT: visitorSendHistory.CONTENT,
      TYPE: visitorSendHistory.TYPE,
      VISITOR_ID: visitorSendHistory.VISITOR_ID,
    })

    if (result.length > 0) {
      return result[0]
    }
    return {
      ERR_CD: "",
      ERR_MSG: "",
      VISITOR_ID: null,
    }
  }

  public async FAR_sr_Fair(fair_id: number): Promise<FAR_sr_Fair[]> {
    return await this.callApi("FAR_sr_Fair", { fair_id })
  }

  public async checkCompanyFairSmsCoupon(params: Coupon): Promise<FAR_sr_CheckCompanyFairSmsCoupon> {
    return await this.callApi("checkCompanyFairSmsCoupon", { COUPON_CODE: params.COUPON_CODE, FAIR_ID: params.FAIR_ID })
  }

  public async getFairVisitorPaymentInfo(params: iFairVisitorPaymentInfo): Promise<any> {
    return await this.callApi("getFairVisitorPaymentInfo", params)
  }

  public async FAR_sd_AgreementMaster(params: iFAR_sd_AgreementMaster): Promise<FAR_sd_AgreementMaster[]> {
    return await this.callApi("FAR_sd_AgreementMaster", params)
  }

  public async FAR_sd_Fair(params: iFAR_sd_Fair): Promise<FAR_sd_Fair[]> {
    return await this.callApi("iFAR_sd_Fair", params)
  }

  public async FAR_sr_FairPromotion(fair_id: number): Promise<FairPromotion> {
    const data = await this.callApi<FairPromotion[]>("FAR_sr_FairPromotion", { fair_id })
    return data[0]
  }

  public async FAR_sd_CompanyFairReqEnterStaff(company_fair_req_id: number): Promise<FAR_sd_CompanyFairReqEnterStaff[]> {
    return await this.callApi("FAR_sd_CompanyFairReqEnterStaff", { company_fair_req_id })
  }

  public async FAR_sd_CompanyFacilReq(params: iFAR_sd_CompanyFacilReq): Promise<FAR_sd_CompanyFacilReq[]> {
    return await this.callApi("FAR_sd_CompanyFacilReq", params)
  }

  public async FAR_sr_FairDoc(fair_id: number): Promise<FAR_sr_FairDoc[]> {
    return await this.callApi("FAR_sr_FairDoc", { fair_id })
  }

  public async FAR_sr_CompanyFairReqSign(company_fair_req_id: number): Promise<FAR_sr_CompanyFairReqSign[]> {
    return await this.callApi("FAR_sr_CompanyFairReqSign", { company_fair_req_id })
  }

  public async FAR_dn_CompanyFairReqEnterStaff(params: iFAR_dn_CompanyFairReqEnterStaff): Promise<FAR_dn_CompanyFairReqEnterStaff> {
    return await this.callApi("FAR_dn_CompanyFairReqEnterStaff", params)
  }

  public async FAR_iu_CompanyFairDocEnter(params: iFAR_iu_CompanyFairDocEnter): Promise<FAR_iu_CompanyFairDocEnter> {
    return await this.callApi("FAR_iu_CompanyFairDocEnter", params)
  }

  public async FAR_sr_CompanyFairReqPromotion(company_fair_req_id: number): Promise<FAR_sr_CompanyFairReqPromotion[]> {
    return await this.callApi("FAR_sr_CompanyFairReqPromotion", { company_fair_req_id })
  }

  public async FAR_sd_FairCategoryALLFromApplication(
    params: iFAR_sd_FairCategoryALLFromApplication,
  ): Promise<FAR_sd_FairCategoryALLFromApplication[]> {
    return await this.callApi("FAR_sd_FairCategoryALLFromApplication", params)
  }

  public async FAR_sd_CompanyFairReqPromotionBrand(company_fair_req_id: number): Promise<FAR_sd_CompanyFairReqPromotionBrand[]> {
    return await this.callApi("FAR_sd_CompanyFairReqPromotionBrand", { company_fair_req_id })
  }

  public async FAR_sd_CompanyFairPromotionInfoAdd(params: iFAR_sd_CompanyFairPromotionInfoAdd): Promise<FAR_sd_CompanyFairPromotionInfoAdd[]> {
    return await this.callApi("FAR_sd_CompanyFairPromotionInfoAdd", params)
  }

  public async FAR_sr_BmsFairByFairId(fair_id: number): Promise<FAR_sr_BmsFairByFairId | false> {
    return await this.callApi("FAR_sr_BmsFairByFairId", { fair_id })
  }

  public async FAR_sd_FairBoard(params: iFAR_sd_FairBoard): Promise<FAR_sd_FairBoard[]> {
    return await this.callApi("FAR_sd_FairBoard", params)
  }

  public async FAR_dn_CompanyFairReqPromotionBrandSingle(
    params: iFAR_dn_CompanyFairReqPromotionBrandSingle,
  ): Promise<FAR_dn_CompanyFairReqPromotionBrandSingle> {
    return await this.callApi("FAR_dn_CompanyFairReqPromotionBrandSingle", params)
  }

  public async FAR_in_CompanyFairReqSign(params: iFAR_in_CompanyFairReqSign): Promise<FAR_in_CompanyFairReqSign> {
    let data = await this.callApi<FAR_in_CompanyFairReqSign[]>("FAR_in_CompanyFairReqSign", params)
    return data[0]
  }

  public async FAR_in_CompanyFairPromotionWithoutFileUpload(
    params: iFAR_in_CompanyFairPromotionWithoutFileUpload,
  ): Promise<FAR_in_CompanyFairPromotionWithoutFileUpload> {
    return await this.callApi("FAR_in_CompanyFairPromotionWithoutFileUpload", params)
  }

  public async FAR_sr_CompanyFairReq(COMPANY_FAIR_REQ_ID: number): Promise<FAR_sr_CompanyFairReq> {
    return await this.callApi("FAR_sr_CompanyFairReq", { COMPANY_FAIR_REQ_ID })
  }

  public async FAR_un_CompanyFairInfoImages(params: iFAR_un_CompanyFairInfoImages): Promise<any> {
    return await this.callApi("FAR_un_CompanyFairInfoImages", params)
  }

  public async FAR_in_CompanyFairReqPromotion(params: iFAR_in_CompanyFairReqPromotion): Promise<FAR_in_CompanyFairReqPromotion> {
    let result = await this.callApi<any>("FAR_in_CompanyFairReqPromotion", params)
    if (result.State == "Success") {
      return result[0]
    }

    return {
      ERR_CD: -1,
      ERR_MSG: "",
      RET_COMPANY_FAIR_PROMOTION_ID: null,
    }
  }

  public async FAR_un_FairEvent(params: iFAR_un_FairEvent): Promise<any> {
    return await this.callApi("FAR_un_FairEvent", params)
  }

  public async FAR_sr_FairPeriod(params: iFAR_sr_FairPeriod): Promise<any> {
    return await this.callApi("FAR_sr_FairPeriod", params)
  }

  public async FAR_un_Prizes(params: iFAR_un_Prizes): Promise<any> {
    return await this.callApi("FAR_un_Prizes", params)
  }
}
